import { useEffect, useRef } from "react";

const TOCITemLine = ({
    isActive,
    style,
    ...props
}: { isActive?: boolean; style: React.CSSProperties } & React.HTMLAttributes<HTMLSpanElement>) => {
    const ref = useRef<HTMLButtonElement>(null);

    useEffect(() => {
        if (isActive) {
            ref.current?.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
        }
    }, [isActive]);

    return (
        <span
            ref={ref}
            style={{
                width: "100%",
                height: "0.3rem",
                borderRadius: "0.5rem",
                marginLeft: "auto",
                flexShrink: 0,
                ...style,
            }}
            {...props}
            data-testid="auto-id-e17a1f5b-5d85-4e9a-9659-9c505ca855f3" />
    );
};

export default TOCITemLine;
